export default __webpack_public_path__ + "static/rx-1da5a806d7689cd09a193343de41d348.svg";